module.exports = __webpack_public_path__ + "static/media/health-management-2023-7.db7257ef.webp";